import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { OptionsPostTypesRow } from "./postTypeRow.js";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
import { ProTag } from "../common/proTag.js";
const OptionsPostTypesTable = observer(()=>{
    const { optionStore: { others: { postTypes } } } = useStores();
    return /*#__PURE__*/ _jsxs("table", {
        className: "wp-list-table widefat fixed striped table-view-list",
        children: [
            /*#__PURE__*/ _jsx("thead", {
                children: /*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx("td", {
                            children: __("Post type")
                        }),
                        /*#__PURE__*/ _jsx("td", {
                            width: 250,
                            align: "right",
                            children: __("Show category tree")
                        }),
                        /*#__PURE__*/ _jsxs("td", {
                            width: 350,
                            align: "right",
                            children: [
                                __("Pagination without page reload"),
                                "\xa0",
                                /*#__PURE__*/ _jsx(ProTag, {
                                    feature: "options-fast-mode"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("tbody", {
                children: [
                    Object.keys(postTypes).map((name)=>/*#__PURE__*/ _jsx(OptionsPostTypesRow, {
                            name: name
                        }, name)),
                    /*#__PURE__*/ _jsxs("tr", {
                        children: [
                            /*#__PURE__*/ _jsx("td", {
                                children: /*#__PURE__*/ _jsx("strong", {
                                    children: __("Media")
                                })
                            }),
                            /*#__PURE__*/ _jsx("td", {
                                colSpan: 2,
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: __("https://devowl.io/go/real-media-library?source=cross-rcm&feature=media-folders"),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: __("Use Real Media Library to enable folder management")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
export { OptionsPostTypesTable };
